var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMandate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5452 16.773L5.46187 14.9746C5.27071 14.9406 5.12964 14.7557 5.12964 14.5378V2.28702C5.12964 2.0606 5.28189 1.87067 5.4823 1.84717L15.5656 1.00247C15.7977 0.974978 16 1.17991 16 1.44232V16.3366C15.9995 16.608 15.7836 16.8155 15.5452 16.773Z",
    fill: "#007BD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4156 18.7833L3.33224 16.9849C3.14107 16.9514 3 16.766 3 16.5481V4.29733C3 4.07091 3.15225 3.88097 3.35267 3.85748L13.436 3.01278C13.668 2.98529 13.8704 3.19021 13.8704 3.45262V18.3469C13.8699 18.6183 13.6544 18.8258 13.4156 18.7833Z",
    fill: "#009DE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1304 6.98738L4.33282 7.30177V5.82479L12.1304 5.18351V6.98738Z",
    fill: "#00C2F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1304 9.77142L4.33282 9.60448V8.12749L12.1304 7.96805V9.77142Z",
    fill: "#00C2F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58476 12.2801L4.33282 11.9147V10.4377L8.58476 10.6146V12.2801Z",
    fill: "#00C2F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandate);
export default __webpack_public_path__ + "static/media/mandate.a9ae9f409d97f2314bf0ffdf1182f35f.svg";
export { ForwardRef as ReactComponent };